/**
 * StringIcon/index.js
 * desc: string data-type icon (includes animation)
 * note: type icon via IconButton; defaults its tooltip + accessible name to the
 *       data-type title. Exported as both the default and a named (ref-able) component.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


export const StringIcon = ({ tooltip, ref, ...props }) => {
    return (
        <IconButton ref={ ref } baseClassName="string icon" label={ tooltip || translate('icons.string.tooltip.text') } tooltip={ tooltip } { ...props }>
            <svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.648.44c.288 0 .432.088.432.264 0 .064-.032.12-.096.168a.556.556 0 0 1-.24.12c-.336.064-.688.2-1.056.408a2.469 2.469 0 0 0-.888.84c-.24.352-.36.808-.36 1.368 0 .192.088.408.264.648.192.24.416.376.672.408.352.032.624.144.816.336.208.176.312.4.312.672 0 .32-.136.584-.408.792-.256.208-.56.312-.912.312a1.847 1.847 0 0 1-1.44-.648c-.368-.448-.552-1.008-.552-1.68 0-.608.12-1.152.36-1.632.24-.496.544-.92.912-1.272A4.665 4.665 0 0 1 7.592.728c.4-.192.752-.288 1.056-.288Zm-4.224 0c.288 0 .432.088.432.264 0 .064-.032.12-.096.168a.556.556 0 0 1-.24.12c-.336.064-.688.2-1.056.408a2.469 2.469 0 0 0-.888.84c-.24.352-.36.808-.36 1.368 0 .192.088.408.264.648.192.24.416.376.672.408.352.032.624.144.816.336.208.176.312.4.312.672 0 .32-.136.584-.408.792-.256.208-.56.312-.912.312a1.847 1.847 0 0 1-1.44-.648C1.152 5.68.968 5.12.968 4.448c0-.608.12-1.152.36-1.632.24-.496.544-.92.912-1.272A4.665 4.665 0 0 1 3.368.728C3.768.536 4.12.44 4.424.44Z"/></svg>
        </IconButton>
    );
};


export default StringIcon;
